import React from 'react';
import PageLayout from '../components/PageLayout';
import { Mail, Phone, MessageCircle } from 'lucide-react';

const SupportPage = () => {
  return (
    <PageLayout title="Support">
      <div className="space-y-8">
        <section>
          <p className="text-lg text-slate-600 mb-8">
            We're here to help you get the most out of your diabetes management journey. 
            Our support team is dedicated to assisting you with any questions or concerns.
          </p>
        </section>

        <section>
          <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-4">Contact Us</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-xl border border-slate-200">
              <Mail className="h-8 w-8 text-emerald-500 mb-4" />
              <h3 className="font-manrope font-bold text-slate-900 mb-2">Email Support</h3>
              <p className="text-slate-600 text-sm mb-3">Get help via email within 24-48 hours.</p>
              <a href="mailto:support@signalpathdigitalapps.com" className="text-emerald-600 font-medium text-sm">
                support@signalpathdigitalapps.com
              </a>
            </div>
            <div className="bg-white p-6 rounded-xl border border-slate-200">
              <Phone className="h-8 w-8 text-emerald-500 mb-4" />
              <h3 className="font-manrope font-bold text-slate-900 mb-2">Phone Support</h3>
              <p className="text-slate-600 text-sm mb-3">Available Monday-Friday, 9am-5pm EST.</p>
              <a href="tel:+1-800-555-0123" className="text-emerald-600 font-medium text-sm">
                1-800-555-0123
              </a>
            </div>
            <div className="bg-white p-6 rounded-xl border border-slate-200">
              <MessageCircle className="h-8 w-8 text-emerald-500 mb-4" />
              <h3 className="font-manrope font-bold text-slate-900 mb-2">In-App Chat</h3>
              <p className="text-slate-600 text-sm mb-3">Get instant help through our app.</p>
              <span className="text-emerald-600 font-medium text-sm">
                Available in the app
              </span>
            </div>
          </div>
        </section>

        <section>
          <h2 className="font-manrope text-2xl font-bold text-slate-900 mb-4">Frequently Asked Questions</h2>
          <div className="space-y-4">
            <div className="bg-white p-6 rounded-xl border border-slate-200">
              <h3 className="font-manrope font-bold text-slate-900 mb-2">How do I reset my password?</h3>
              <p className="text-slate-600">
                You can reset your password by tapping "Forgot Password" on the login screen. 
                We'll send you an email with instructions to create a new password.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl border border-slate-200">
              <h3 className="font-manrope font-bold text-slate-900 mb-2">How do I sync my glucose meter?</h3>
              <p className="text-slate-600">
                Go to Settings > Connected Devices and select your glucose meter from the list. 
                Follow the on-screen instructions to complete the Bluetooth pairing.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl border border-slate-200">
              <h3 className="font-manrope font-bold text-slate-900 mb-2">Can I export my health data?</h3>
              <p className="text-slate-600">
                Yes! Go to Settings > Data & Privacy > Export Data. You can export your data in PDF 
                or CSV format to share with your healthcare team.
              </p>
            </div>
          </div>
        </section>
      </div>
    </PageLayout>
  );
};

export default SupportPage;
